import React, { useCallback, useMemo, useState } from "react";
import { View } from "react-native";
import { useI18n, useI18nMessage } from "@lookiero/i18n-react";
import { CURRENCY } from "@lookiero/sty-psp-locale";
import { Text } from "@lookiero/sty-psp-ui";
import { Slider } from "@lookiero/sty-psp-ui";
import { useAnswerForId } from "../../behaviours/useAnswers";
import { style as hostPriceSliderQuestionItemStyle } from "./HostPriceSliderQuestionItem.style";
const HostPriceSliderQuestionItem = ({ question, domain, tradename, segment, country, }) => {
    const style = useMemo(() => hostPriceSliderQuestionItemStyle(), []);
    const titleText = useI18nMessage({ domain, id: question.translationKey, values: { segment: segment.toLowerCase() } });
    const { formatNumber } = useI18n({ domain });
    const { answer, onChange } = useAnswerForId({ id: question.id });
    const selectedAnswer = answer && answer[0];
    const [value, setValue] = useState(selectedAnswer);
    const { sliderValue, min, max } = useMemo(() => {
        const values = question.children.map((child) => parseInt(child.translationKey));
        const sliderValue = parseInt(question.children.find((child) => child.id === value)?.translationKey);
        return {
            sliderValue,
            min: Math.min(...values),
            max: Math.max(...values),
        };
    }, [question.children, value]);
    const questionChild = useCallback((value) => {
        const child = question.children.find((child) => child.translationKey === `${value}`);
        if (!child) {
            console.warn(`No child found for value ${value} in question ${question.id}`);
            return;
        }
        if (child.id === selectedAnswer) {
            return;
        }
        return child;
    }, [question.children, question.id, selectedAnswer]);
    const handleOnChange = useCallback((value) => {
        const child = questionChild(value);
        if (!child) {
            return;
        }
        setValue(child.id);
    }, [questionChild]);
    const handleOnSlidingComplete = useCallback((value) => {
        const child = questionChild(value);
        if (!child) {
            return;
        }
        onChange({
            questionId: question.id,
            answer: child.id,
        });
    }, [onChange, question.id, questionChild]);
    const formatValue = useCallback((value) => formatNumber(value, {
        style: "currency",
        currency: CURRENCY[country],
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }), [country, formatNumber]);
    return (React.createElement(View, { style: style.container, testID: "host-price-slider-question-item" },
        React.createElement(Text, null, titleText),
        React.createElement(Slider, { formatValue: formatValue, max: max, min: min, steps: question.children.length - 1, tradename: tradename, value: sliderValue, onChange: handleOnChange, onSlidingComplete: handleOnSlidingComplete })));
};
export { HostPriceSliderQuestionItem };
